webpackJsonp([77],{

/***/ 1260:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1261);


/***/ }),

/***/ 1261:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(174);

var _datetime2 = _interopRequireDefault(_datetime);

var _en = __webpack_require__(772);

var _en2 = _interopRequireDefault(_en);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('en', _en2.default);

/***/ })

},[1260]);


// WEBPACK FOOTER //
// app/datetime.en-ef4c5e792814892370d1.js